<template>
  <ProfileForm class="profile" />
</template>

<script>
import { mapActions } from 'vuex'
import { ACTION_GET_PROFILE } from '../store/types/profile.types'
import ProfileForm from '../components/profile/ProfileForm'

export default {
  name: 'ProfilePage',
  components: {
    ProfileForm,
  },
  mounted() {
    this.getProfile()
  },
  methods: {
    ...mapActions({
      getProfile: ACTION_GET_PROFILE,
    }),
  },
}
</script>

<style scoped>
  .profile {
    height: 100%;
    overflow: auto;
    display: flex;
  }
  @media only screen and (min-width: 1264px) {
    .profile {
      margin: 0 200px;
    }
  }
</style>
